import { getEntityTemplateLang } from '~services/entity-definitions/helpers';
import { createTemporaryEntityId } from '~services/entity-definitions/template-helpers';

export default () => ({
  data: {
    type: 'paragraph--teasers_item',
    id: createTemporaryEntityId(),
    attributes: {
      langcode: getEntityTemplateLang(),
      status: true,
      default_langcode: true,
      field_hide_title: false,
      field_link_external: null,
      field_link_module: null,
      field_link_text: '',
      field_search_text: null,
      field_text: {
        value: 'Morbi +1 nam molestie before they sold out adipiscing vivamus',
        format: null,
      },
      field_title: { value: 'I am a Teaser Item', format: 'rich_text' },
    },
    relationships: {
      field_image: {},
      field_tags: {
        data: [],
      },
    },
    links: {},
    log: [],
    permissions: {
      update: true,
      create: true,
      delete: true,
    },
  },
  included: [],
});
